const common = {
  siteName: '成全影视',
  siteSlogan: '免费在线观看看不停',
  home: '首页',
  about: '关于我们',
  all: '全部',
  search: '搜索你想看的剧集...',
  more: '查看更多',
  hot: '热门推荐',
  latest: '最新更新',
  rating: '评分',
  episodes: '集数',
  year: '年份',
  actors: '主演',
  director: '导演',
  region: '地区',
  updateInfo: '更新状态',
  readMore: '阅读更多',
  backToList: '返回列表',
  prevPage: '上一页',
  nextPage: '下一页',
  noResult: '暂无相关内容',
  contactUs: '联系我们',
  copyright: '© 2024 成全影视 版权所有',
  allRightsReserved: '保留所有权利',
  privacyPolicy: '隐私政策',
  termsOfService: '服务条款',
  footerDesc: '成全影视提供电视剧全集播放，不缓冲看剧免费在线观看，全集免费电视剧流畅追剧完整版，热门电视剧大全免费高清在线免VIP观看。',
  categoryTitle: '分类浏览',
  articleList: '最新资讯',
  readCount: '阅读',
  publishDate: '发布时间',
  tags: '标签',
  relatedArticles: '相关文章',
  breadcrumbHome: '首页',
};

export default common;